import React,{useContext,useState} from 'react';
import { AlertTriangle, X } from 'lucide-react';

import { updateVendeurInfo } from '../../db/users/updateVendeurInfo';
import AppContext from '../../context/AppContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserKeysService } from '../../db/Aggregator/UserKeysService';
import ComingSoonAlert from '../espace/ComingSoonAlert'

const TestPlanAlert = ({ onClose }) => {
    const { isSplashVisible, isLoading,id } = useContext(AppContext);
    const [showAlert, setShowAlert] = useState(true);
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="relative bg-gradient-to-b from-white to-yellow-50 rounded-3xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
        <div className="absolute top-0 left-0 w-32 h-32 bg-yellow-100 rounded-full -translate-x-16 -translate-y-16" />
        <div className="absolute bottom-0 right-0 w-32 h-32 bg-orange-100 rounded-full translate-x-16 translate-y-16" />
        
        <div className="relative">
          <div className="flex justify-center pt-4">
            <div className="w-12 h-1 bg-gray-200 rounded-full" />
          </div>
          
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={20} />
          </button>
          
          <div className="flex justify-center mt-8">
            <div className="bg-yellow-100 p-3 rounded-2xl">
              <AlertTriangle className="h-8 w-8 text-yellow-600" />
            </div>
          </div>
          
          <div className="px-6 pt-6 pb-8 text-center">
            <h2 className="text-xl font-bold text-gray-900 mb-2">
              Plan de Test Uniquement
            </h2>
            <p className="mt-2 text-gray-600">
              Ce plan est actuellement disponible pour des tests uniquement. 
              La gestion des retraits n'est pas encore implémentée. Pour une solution 
              complète, veuillez opter pour le plan Premium qui va vous permttre de définir les key de vos agrégateurs
            </p>
          </div>
          
          <div className="px-6 pb-8 space-y-3">
            <button
              onClick={ async()=>{

                  UserKeysService.saveUserKeys(
                            id,
                            "monero",              // Sera converti en "binance"
                            {
                              apiKey: "pvk_41z3r1|01J9BV23GNVNDKZSRSC5QC68R0",
                              secretKey: "ma-clé-secrète"
                            }
                          );
                
                
                          UserKeysService.saveUserKeys(
                            id,
                            "fedapay",              // Sera converti en "binance"
                            {
                              apiKey: "pk_live_e7dw71_p7JaRpeIdtSscgyIl",
                              secretKey: "ma-clé-secrète"
                            }
                          );



                           try {
                                   if(id!=undefined){
                            
                                    await updateVendeurInfo(id, {
                                      // balanceGratuit: 100,
                                     //  plan: true,
                                       plan:true,
                                       type_plan:"gratuit"
                                   });
                                   console.log("Mise à jour réussie");
                                   navigate("/IndexEspace")
                                   }
                                } catch (error) {
                                    console.error("Erreur lors de la mise à jour:", error);
                                }
              }


              }
              className="w-full py-3 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white font-medium rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
            >
              Tester ce plan
            </button>
            <button
              onClick={onClose}
              className="w-full py-3 bg-gradient-to-r from-gray-100 to-gray-200 hover:from-gray-200 hover:to-gray-300 text-gray-800 font-medium rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
            >
              Voir le plan Premium
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestPlanAlert;